// var countup = require('countup.js');

function resizeImage(image, container, amountToScroll){
    var dimensions = getAdjustedImageDimensions(image, container, amountToScroll);
    image.height(dimensions.height);
    image.width(dimensions.width);   
		positionImage(image, amountToScroll);
}

function positionImage(image, amountToScroll){
	var wHeight = $(window).height();
	var wTop     = $(window).scrollTop();
	var imageHeight = image.height();
  var imageTop = image.offset().top;
  var imageBottom = imageTop + imageHeight;
	var rangeTop = imageTop - wHeight;
	var rangeBottom = imageBottom;
	var rangeLength = rangeBottom - rangeTop;
	var distanceInRange = wTop - rangeTop;
	var percent = distanceInRange*100/rangeLength;
	var offset = (amountToScroll * (percent/100) - (amountToScroll * .5));
	image.css({marginTop: -offset})
};	

function getAdjustedImageDimensions(image, container, amountToScroll){
	var originalHeight = image[0].naturalHeight;
	var originalWidth = image[0].naturalWidth;
	
	var containerHeight = container.height();
	var containerWidth = container.width();
	
	//Give a little breathing room
	var imageMinWidth = containerWidth + 100;
	var imageMinHeight = containerHeight + amountToScroll;
	
	var adjustedWidth = imageMinWidth;
	var adjustedHeight = adjustedWidth * (originalHeight/originalWidth);
	
	if (adjustedHeight < imageMinHeight) {
	  adjustedHeight = imageMinHeight;
	  adjustedWidth = adjustedHeight * (originalWidth/originalHeight);
	}
	return { 
	  height: adjustedHeight,
	  width: adjustedWidth
	};
}


$(document).ready(function(){

	//search
	$('#search-trigger').on("click", function(e) {
		$('.search-overlay').addClass('open');
	});

	$('.search-closer').on("click", function(e) {
		//e.preventDefault();
		$('.search-overlay').removeClass('open');
	});

	// var amountToScroll = 400;
	// var plaxSelector = $('.banner-image-container');
	// plaxSelector.each(function(){
	// 	var containerEl = $(this);
	// 	var image_url = containerEl.css('background-image').slice(4, -1).replace(/"/g, "");
	// 	var img = new Image();
	// 	img.className = "parallax-img";
	// 	img.alt="Page Banner Image"
	// 	img.onload = function(){
	// 		imageEl = $(this);
	// 		containerEl.attr('style', '');
	// 		containerEl.prepend(imageEl);
	// 		resizeImage(imageEl, containerEl, amountToScroll);
	// 		$(window).on({
	// 			resize: function() {
	// 				//var amountToScroll = parseInt( containerEl.data('scroll') ) || amountToScroll;
	// 				//console.log("data-scroll: " + containerEl.data('scroll'));
	// 				resizeImage(imageEl, containerEl, amountToScroll);
	// 			}, 
	// 			scroll: function() {
	// 				//var amountToScroll = parseInt( containerEl.data('scroll') ) || amountToScroll;
	// 				positionImage(imageEl, amountToScroll);
	// 			}
	// 		});	
	// 	}
	// 	img.src=image_url;
	// });
	

  
});


$(document).ready(function($) {

	var ww = $(window).width();

	//mobile menu
	$('.menu-toggle').on("click", function(e){
		$(this).toggleClass('closer');
		$('.nav-primary').toggleClass('open');
		$('body').toggleClass('lock');
	});

	//submenu
	if (ww < 1000) {		

		$('.dropdown .caret').on("click", function(e){
			var link = $(this).parents('.dropdown');		    				 		
				
		    var sub_menu = link.children('.sub-menu');

		    link.toggleClass('open');
		    
		    if( ww < 800 ){
		        link.hasClass('open') ? sub_menu.slideDown() : sub_menu.slideUp();
		    } else {
		        link.hasClass('open') ? sub_menu.addClass('show') : sub_menu.removeClass('show');
		    }

		});	
	}

	$('iframe[src*=youtube], iframe[src*=vimeo]').parents().fitVids();

	//banner vid
	initVideo();

	//frontpage banner animation
	setTimeout( function() {
		$(".frontpage-banner .caption-container").addClass("showing"); }, 300
	);
	setTimeout( function() {
		$(".frontpage-banner .title").addClass("showing"); }, 500
	);	
	setTimeout( function() {
		$(".frontpage-banner .caption").addClass("showing"); }, 600
	);

	//secondary banner animation
	setTimeout( function() {
		$(".caption-container").addClass("showing"); }, 300
	);
	setTimeout( function() {
		$(".page-title").addClass("showing"); }, 500
	);	
	setTimeout( function() {
		$(".caption").addClass("showing"); }, 600
	);

	//init Swipe
  $( '.swipebox' ).swipebox({
		hideBarsDelay:0,
	});


	//At A Glance Slider
	$('.at-a-glance-slider').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		  responsive: [
		    {
		      breakpoint: 1000,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		    // You can unslick at a given breakpoint now by adding:
		    // settings: "unslick"
		    // instead of a settings object
		  ]
	});

	$('.slider-wrap .arrows-container .prev-arrow').on("click", function(e) {
		$('.at-a-glance-slider').slick('slickPrev');
	});

	$('.slider-wrap .arrows-container .next-arrow').on("click", function(e) {
		$('.at-a-glance-slider').slick('slickNext');
	});	


	//load more impact posts
	$('.load-more-posts').on("click", function(){
		var button = $(this);
		var page_number = parseInt(button.data('next-page'));
		var original_text = button.html();

		button.html("Loading...");
		button.toggleClass('loading-posts');


		$.ajax({
			url: ajaxurl,
			type: 'POST',
			data: {
				paged: page_number,
				action: 'ajax_more_posts'
			},
		})
		.done(function(result) {
			if( parseInt( button.data("next-page") ) == parseInt( button.data("max-pages") ) ) {
				button.addClass('hidden');
			} else {
				var next_page_number = page_number + 1;			
				button.data("next-page", next_page_number);				
			}
			
			button.toggleClass('loading-posts');
			button.html(original_text);
			$('.loading-button-wrap').before(result);


		})
		.fail(function(err) {
			console.log(err);
		})
		.always(function() {
			// console.log("complete");
		});
		
	});

});

$(window).load(function() {
	//equalize height
	equalizeHeight(".cft-g.featured-giving-opportunity-grid .cft-gi a .text-box");
	equalizeHeightMultirow(".cft-g.giving-opportunity-master-grid .cft-gi a .text-box");
	equalizeHeight(".cft-g.your-impact-grid .cft-gi .text-box");
	//equalizeHeight(".at-a-glance-slider .single-slide");
	equalizeHeight(".cft-g.at-a-glance-grid .cft-gi .gi-inner .caption");
});

function initVideo(){
	if(!$('#init-video').length) return false;
	var ww = $(window).width();	
	var videoConfig = JSON.parse($("#init-video").html());
	
        // var videoWrap = $('<div class="banner-video-wrapper"></div');
		var video = $('<video id="bgvid" muted autoplay playsinline loop poster="'+videoConfig.poster+'"></video>');
		for (src in videoConfig.srcset){
			if (videoConfig.srcset.hasOwnProperty(src)){
				var source = $('<source></source>', {	    
					src: videoConfig.srcset[src],
					type:"video/"+src
				});
				video.append(source);
			}
		}

        // videoWrap.append(video);

		video.insertAfter($("#init-video"));
		// var vid_el = document.getElementById("bgvid");
        // vid_el.playbackRate = 0.75;

	
    // $('.video-wrapper').fitVids();

    // setTimeout(function () {
    // }, 3000);
	
}

function equalizeHeight(target) {
    //equalize height
    var maxHeight = 0;

    $(target).each(function(){
       if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });

    $(target).height(maxHeight);
}

function equalizeHeightMultirow(target) {

	rows = {};
	currentRowOffset = false;	

	$(target).each(function(){
	    
	    var offset = $(this).offset().top;

	    //console.log(offset);

	    if (offset !== currentRowOffset){	    	
	        //new row... reset variables...

	        currentRowOffset = offset;
	        rows[offset] = {
	            items: [],
	            maxHeight:false,
	        };
	    }
	    
	    rows[offset].items.push($(this));
	    if ($(this).height() > rows[offset].maxHeight) { rows[offset].maxHeight = $(this).height(); }
	    
	});	


	var keys = Object.keys(rows);
	for( var i = 0; i < keys.length ; i++){
		var rowdata =  rows[keys[i]];
		var items = rowdata.items;
		var h = rowdata.maxHeight;

		$(items).each( function(){
			$(this).height(h);
		});
	}
}


// 2021
function testForAnimation(){
	var animations = $('[animate-on-scroll]');

	if (animations.length < 1) return false;
	
	var marker = ($(window).height()/1.33) + $(window).scrollTop();

	animations.each(function(){
		if ($(this).hasClass('animated')) return true;        

		var triggerHeight = $(this).offset().top;
		if (triggerHeight<marker){ // if the triggerHeight has been passed
			if ($(this).attr('animate-on-scroll') && !$(this).hasClass('animated')){
				window[$(this).attr('animate-on-scroll')]($(this));
			}
			$(this).addClass('animated');
		}
	});
	
}//testForAnimation

function testForCounter(){
	var scrollTarget = $('.donut-wrap');

	if (scrollTarget.length < 1) return false;
	
	var marker = ($(window).height()/1.33) + $(window).scrollTop();
    var triggerHeight = $('.donut-wrap').offset().top;
    if ( triggerHeight<marker ){ // if the triggerHeight has been passed
        if ( !$('.donut-wrap').hasClass('animated') ){
            // countup
            var options = {
              decimalPlaces: 3
            };
            var counter = new CountUp('countMe', $('.donut-wrap').attr('data-count'), options);
            if (!counter.error) {
                counter.start();
            } else {
                counter.error(counter.error);
            }
            $('.donut-wrap').addClass('animated');
        }
    }
        
	
}// testCounter

$(window).on('load', function() {
    $('.loading').addClass('hidden');
});

$(document).ready(function(){

    function scrollEvents() {
        testForAnimation();
        testForCounter();
    }
    window.addEventListener('scroll', scrollEvents);

    $('.video-wrapper').fitVids();

    //sticky footer
    var minH = $(window).height() - ( $('header.banner').height() + $('.super-header').height() + $('footer').outerHeight() ) + ($(window).width() > 1000 ? 110 : 80);
    $('.wrap').css({minHeight:minH});

    // modal video
    var modalVideoSrc = "https://player.vimeo.com/video/642318368?h=912f59bc72&byline=0&portrait=0&title=0";

    $("#video-button").on('click', function() {
        $('.modal-video').attr('src', modalVideoSrc);
        $('.modal-wrapper .video-wrapper').fitVids();
        $('body').toggleClass('lock');
        $('.modal-wrapper').addClass('visible');
    });

    $('.modal-wrapper .close-button').on('click', function() {
        $('.modal-wrapper').removeClass('visible');
        $('.modal-video').attr('src', '');
        $('body').toggleClass('lock');
    });
    // end modal video
	
    $(".toggle_container").hide();
    $("h3.trigger").click(function(){
	    $(this).toggleClass("active").next().slideToggle("normal");
	    return false; //Prevent the browser jump to the link anchor
	});

    // campaign opportunity text expander
    $('.campaign-opportunity-more-link').on('click', function(e) {
        e.preventDefault();

        $(this).toggleClass('closed')
        $(this).text(($(this).hasClass('closed') ? 'Read More' : 'Read Less'));
        
        if ( $(this).hasClass('closed') ) {
            $(this).text('Read More');
            $(this).siblings('.expandable-text').slideUp();
        } else {
            $(this).text('Read Less');
            $(this).siblings('.expandable-text').slideDown();
        }
    });

        
	
});